import Vue from 'vue'
import Vuex from 'vuex'
// import createPersistedstate from 'vuex-persistedstate'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // user:"",
    user: { token: '', username: '' },
    navigationMsg:null,
    conditionsList:{},//查询条件的数组
    titleListNew:JSON.parse(window.sessionStorage.getItem("titleListNew")||"[]")
  },
  // plugins:[
  //   createPersistedstate({
  //     key:'user'
  //   })
  // ],
  mutations: {
    adduser(state,data){
      // state.user=data;
      state.user.username = data.username
      state.user.token = data.token
      window.sessionStorage.setItem("user",encodeURIComponent(JSON.stringify(data)));
    },
    addnavigationMsg(state,data){
      state.navigationMsg=data;
      window.sessionStorage.setItem("navigationMsg",JSON.stringify(data));
    },
    addTitleList(state,data){

      if(data.path!="/building"){
        let have=state.titleListNew.some(item=>{
          return item.path===data.path;
        });
        if(have) return ""
        if(state.titleListNew.length>10) state.titleListNew.splice(1,1);
        state.titleListNew.push(data);
        window.sessionStorage.setItem("titleListNew",JSON.stringify(state.titleListNew));
      }else{
        return
      }
     
    },
    delTitleList(state,index){
      state.titleListNew.splice(index,1);
      window.sessionStorage.setItem("titleListNew",JSON.stringify(state.titleListNew));
    },
    createConditions(state,obj){
      obj.key&&(state.conditionsList[obj.key]=obj.val||{page:1,limit:20});
    },
    clearConditions(state,key){
      state.conditionsList[key]&&(state.conditionsList[key]=null);
    },
    remove(state){
      state.user.token = ''
      state.user.username = ''
      state.user.titleListNew = []
      window.sessionStorage.removeItem("user");
      window.sessionStorage.removeItem("defaultactive");
      window.sessionStorage.removeItem("titleListNew")
      window.localStorage.removeItem("user");
    }
  },
  actions: {
  },
  modules: {
  },
  getters: {
    usergt(state){
      return JSON.parse(decodeURIComponent(window.sessionStorage.getItem("user")));
    },
    navigationMsgGt(state){
      return state.navigationMsg||JSON.parse(window.sessionStorage.getItem("navigationMsg"));
    },
    user_token(state) { 
      return state.user.token
    }
  }
})
